import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/global.css";
import "./styles/signals.css";
import "./styles/signals-redesign.css";
import "./styles/signal-detail-redesign.css";
import "./styles/slice-b-surfaces.css";
import "./styles/recipient-redesign.css";
import "./styles/contacts.css";
import "./styles/rig.css";
import "./styles/company-search.css";
import "./styles/sweep-control.css";
import "./styles/settings-operations.css";
import "./styles/outreach-draft.css";
import "./styles/radar.css";

// BDSE Production application entry point.
// Implements the SCF ANKURA-SF v0.8 ontology with Edge Function authority pattern.

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error(
    'Root element #root not found. Check that index.html includes <div id="root"></div>.'
  );
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
